import {
  advancedFormControl,
  FormControlTypeEnum,
} from '@magieno/common';
import { IsBoolean, IsInt, IsNotEmpty, IsOptional } from '@pristine-ts/class-validator';
import { FieldTypeEnum } from '../../../../../enums/field-type.enum';
import { translationBaseKey } from '../../../../../decorators/translation-base-key.decorator';
import { ErrorMessageBuilder } from '../../../../../builders/error-message.builder';
import { IncomeTaxPersonalChildCommonOptions } from '../common/income-tax-personal-child-common.options';

@translationBaseKey('income-tax-personal-child-quebec-options')
export class IncomeTaxPersonalChildQuebecOptions extends IncomeTaxPersonalChildCommonOptions {
  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'Frais de garde admissible au Québec',
        en: 'Other Quebec admissible care expenses',
      },
      tooltip: {
        fr: 'Indiquez le montant des autres frais de garde admissibles pour l\'enfant. Les frais de garde admissibles peuvent être utilisés pour réclamer des crédits d\'impôt pour frais de garde au Québec.',
        en: 'Specify the amount of other eligible childcare expenses for the child. Eligible childcare expenses can be used to claim childcare tax credits in Quebec.',
      },
    },
    fieldType: FieldTypeEnum.Money,
    type: FormControlTypeEnum.Input,
  })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  careExpensesOthers: number;

  @advancedFormControl({
    displayableElements: {
      labelTitle: {
        fr: 'Est-ce que votre enfant est aux études?',
        en: 'Is your child studying?',
      },
      tooltip: {
        fr: 'Indiquez si votre enfant est aux études. Le statut d\'étudiant peut avoir des répercussions sur certaines déductions fiscales.',
        en: 'Specify if your child is studying. The student status may have implications for certain tax deductions.',
      },
    },
    fieldType: FieldTypeEnum.Boolean,
    type: FormControlTypeEnum.BooleanSelect,
  })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsBoolean({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsOptional()
  isStudying?: boolean = false;
}
